const LOGO_URL = "https://customer-assets.emergentagent.com/job_55d8f0a9-10a3-4632-9c2f-47ab4244182d/artifacts/ganp80c6_logo_symbol.png";

export function LogoMark({ size = 28, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Aqion"
      width={size}
      height={size}
      className={`aq-logo-blend ${className}`}
      style={{ width: size, height: size, objectFit: "contain" }}
      data-testid="aqion-logo-mark"
    />
  );
}

export function Logo({ className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="aqion-logo">
      <LogoMark size={26} />
      <span className="font-serif-display text-[1.45rem] tracking-tight leading-none">Aqion</span>
    </div>
  );
}
